import { Injectable } from '@angular/core';
import { FeatureTypes } from '@core/user';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BaseGuard } from './base.guard';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class SystemFeatureGuard extends BaseGuard {

  constructor() {
    super();
  }

  protected override _checkCanActivate() {
    if (this._hasFeature(FeatureTypes.AdministrationRvs)
      && !this._userController.isRapidViewsUser
    ) { return true; }

    this._redirectToBaseRoute();

    return false;
  }
}
